module.exports = __webpack_public_path__ + "img/CloudCanvas.82fd9ce 1.1c4ba59.svg";